import { Image, Modal } from "react-bootstrap"
import { withTranslation } from "react-i18next"
import iconRecheck from '../img/icons/recheck.svg'

function ModalSuccess({t, show, setShow}){

    const handleClose = () => setShow(false)

    return(
        <Modal show={show} onHide={handleClose} centered className="border-0">
            <Modal.Body className="p-0">
                <div className="text-center position-relative overflow-hidden h-100p">
                    <Image src={iconRecheck} fluid className="img-recheck"/>
                    <h5 className="mb-0 text-app-success">{t('solicitud_exitosa')}</h5>
                </div>                
            </Modal.Body>
        </Modal>
    )

}
export default withTranslation()(ModalSuccess)